// extracted by mini-css-extract-plugin
export var brand = "_4z-9";
export var compact = "_4z-6";
export var extraSmall = "_4z-7";
export var icon = "_4z-0";
export var large = "_4z-4";
export var light = "_4z-1";
export var medium = "_4z-5";
export var outline = "_4z-b";
export var primaryDark = "_4z-a";
export var primaryLight = "_4z-8";
export var primaryModern = "_4z-c";
export var success = "_4z-2";
export var successSolid = "_4z-3";